import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
axios.defaults.timeout = 15000; // 15秒超时
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'; // post请求头

// 封装get
export function get(url){
    return new Promise((resolve, reject) =>{
        axios.get(url)
            .then(res => {
                resolve(res.data);
            }).catch(err =>{
                reject(err.data)
            })
    });
}

// 封装get - 带参数
export function getByParams(url, params){
    return new Promise((resolve, reject) =>{
        axios.get(url, params)
            .then(res => {
                resolve(res.data);
            }).catch(err =>{
            reject(err.data)
        })
    });
}

//封装post
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, JSON.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err =>{
                reject(err.data)
            })
    });
}
